class WaveController {
    constructor(wawes:WavesConfig){
        this.waves = wawes;
        for (let i =0; i < wawes.waves.length; i++) {
            wawes.waves[i].index = i;
            if (wawes.waves[i].name == 'cycle1') {
                this.cycleIndex = i;
            }
        }
        this.inited = false;
    }
    public inited:boolean;
    public multiplier = 1.1;
    public cycleIndex = 0;
    
    public update(msAbs:number):void {
        if (this.currentWave) {
            this.currentWave.update(msAbs);
        }
    }
    
    public waves:WavesConfig;
    public currentWave:StartedWave;
    
    public initIfNeeded():void {
        if (!this.inited) {
            this.selectNextWave(null);
            this.inited = true;
        } 
    }
    
    private selectNextWave = (finishedWave:StartedWave, overrideIndex:number = 0) => {
        if (finishedWave) {
            finishedWave.onDone.removeListener(this.selectNextWave);
        }
        let index:number;
        if (overrideIndex) {
            index = overrideIndex;    
        } else {
            if (!this.currentWave) {
                index = 0;
            } else {
                index = this.currentWave.porto.index;
                index++;
            }
        }
        
        if (index < this.waves.waves.length) {
            this.currentWave = new StartedWave(this.waves.waves[index]);
            this.currentWave.onDone.addListener(this.selectNextWave);
        } else {
            for (let i = this.cycleIndex; i < this.waves.waves.length; i++) {
                this.waves.waves[i] = this.boostWawe(this.waves.waves[i]);
            }
            this.selectNextWave(finishedWave, this.cycleIndex);
        }
    }
    
    private boostWawe(proto: Wave): Wave {
        let res: Wave = {} as Wave;
        for (let key in proto) {
            (<any>res)[key] = (proto as any)[key];
        }
        for (let sub of res.subWaves) {
            sub.count = ((sub.count * this.multiplier) | 0) + 1;
        }
        return res as Wave;
    }
}